import React from 'react';

import {hooks} from '../../hooks';
import {custom} from '../../custom';
import {components} from '../../components';
import {theme} from '../../constants';
import {svg} from '../../assets/svg';

export const SendPhoneOtp: React.FC = () => {
  const navigate = hooks.useAppNavigate();

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header goBack={true} title='شماره تلفن خود را تأیید کنید' />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          paddingBottom: 20,
          paddingTop: 20,
        }}
      >
        <p
          style={{
            margin: 0,
            ...theme.fonts.Mulish_400Regular,
            fontSize: 16,
            color: theme.colors.textColor,
            marginBottom: 40,
            lineHeight: 1.7,
          }}
        >
          برای شما پیامکی با کد به شماره: 09115749390 ارسال کرده ایم.
        </p>
        <custom.InputField
          label='شماره تلفن'
          icon={<svg.InputCheckSvg />}
          placeholder='شماره تلفن را وارد کنید'
          containerStyle={{marginBottom: 20}}
        />
        <components.Button
          title={'تایید کنید'}
          onClick={() => {
            navigate('/VerifyPhone');
          }}
        />
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
